module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/snake.1219fc24.png";